import { TCountryCode, getCountryData, getEmojiFlag } from "countries-list";

export const getCountryInfo = (countryCode: string) => {
  return {
    ...getCountryData(countryCode as TCountryCode),
    emojiFlag: getEmojiFlag(countryCode as TCountryCode),
  };
};
